import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import './styles/global.css';

// ── DevTools 招呼（彩蛋 A）──
// 开发者打开 console 才看到的一句问候 + 站源码地址。
// 颜色取 Aurora accent (#ff7e5f) — 跟首页 BlobField 同色系
if (typeof window !== 'undefined') {
  const banner = [
    '',
    '   ╱╲   s-blog',
    '  ╱  ╲   ─────',
    ' ╱ AU ╲  Vue 3 · NestJS · Aurora',
    '╱──────╲ 欢迎来到 console~',
    '',
  ].join('\n');
  console.log(
    `%c${banner}`,
    'color: #ff7e5f; font-family: ui-monospace, "JetBrains Mono", monospace; line-height: 1.55; font-size: 12px;',
  );
}

createApp(App).use(router).mount('#app');
